package io.horion.cv.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.text.SpanText
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Text


@Composable
fun PaginationControls(
    currentPage: Int,
    totalPages: Int,
    onPageChange: (Int) -> Unit,
    isMobile: Boolean
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(topBottom = 10.px),
        horizontalArrangement = Arrangement.Center,
        verticalAlignment = Alignment.CenterVertically
    ) {
        // Bouton Précédent

        Button(
            onClick = { onPageChange(currentPage - 1) },
            enabled = currentPage > 0,
            modifier = Modifier
                .width(if (isMobile) 80.px else 100.px)
                .height(if (isMobile) 30.px else 40.px)
                .fontFamily(INTER)
                .fontSize(if (isMobile) 12.px else 14.px)
                .fontWeight(FontWeight.SemiBold)
                .borderRadius(7.px)
                .border(2.px, LineStyle.Solid, Colors.border)
                .color(if (currentPage > 0) Colors.secondary else Colors.LightGray)
                .margin(top = 8.px)
        ) {
            Text("◀ Précédent")
        }
        // Numéros de pages
        Row(
            horizontalArrangement = Arrangement.spacedBy(8.px, Alignment.CenterHorizontally),
            verticalAlignment = Alignment.CenterVertically
        ) {
            // Affiche un sous-ensemble des pages
            val pageRange = getPageRange(currentPage, totalPages)

            if (pageRange.first() > 0) {
                PageNumberButton(
                    page = 0,
                    isCurrent = false,
                    onClick = { onPageChange(0) }
                )
                if (pageRange.first() > 1) {
                    SpanText("...", modifier = Modifier.margin(leftRight = 4.px))
                }
            }

            pageRange.forEach { page ->
                PageNumberButton(
                    page = page,
                    isCurrent = page == currentPage,
                    onClick = { onPageChange(page) }
                )
            }

            if (pageRange.last() < totalPages - 1) {
                if (pageRange.last() < totalPages - 2) {
                    SpanText("...", modifier = Modifier.margin(leftRight = 4.px))
                }
                PageNumberButton(
                    page = totalPages - 1,
                    isCurrent = false,
                    onClick = { onPageChange(totalPages - 1) }
                )
            }
        }

        // Bouton Suivant
        Button(
            onClick = { onPageChange(currentPage + 1) },
            enabled = currentPage < totalPages - 1,
            modifier = Modifier
                .width(if (isMobile) 80.px else 100.px)
                .height(if (isMobile) 30.px else 40.px)
                .fontFamily(INTER)
                .fontSize(if (isMobile) 12.px else 14.px)
                .fontWeight(FontWeight.SemiBold)
                .borderRadius(7.px)
                .border(2.px, LineStyle.Solid, Colors.border)
                .color(if (currentPage < totalPages - 1) Colors.Blue else Colors.LightGray)
                .margin(top = 8.px)
        ) {
            SpanText("Suivant ▶")
        }
    }
}

@Composable
fun PageNumberButton(
    page: Int,
    isCurrent: Boolean,
    onClick: () -> Unit
) {
    Button(
        onClick = { onClick() },
        modifier = Modifier
            .size(36.px)
            .borderRadius(7.px)
            .border(
                width = if (!isCurrent) 2.px else 0.px,
                style = LineStyle.Solid,
                color = Colors.LightGray
            )
            .backgroundColor(if (isCurrent) Colors.Blue else Colors.White)
            .color(if (isCurrent) Colors.White else Colors.Black)
    ) {
        Text(
            "${page + 1}"
        )
    }
}

// Fonction utilitaire pour déterminer quelles pages afficher
fun getPageRange(currentPage: Int, totalPages: Int, maxDisplayed: Int = 5): IntRange {
    val half = maxDisplayed / 2
    var start = currentPage - half
    var end = currentPage + half

    if (start < 0) {
        end += -start
        start = 0
    }
    if (end >= totalPages) {
        start -= (end - totalPages + 1)
        end = totalPages - 1
    }

    start = maxOf(start, 0)
    end = minOf(end, totalPages - 1)

    return start..end
}
